import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--breadcrumbs",
  "use": "icon-arrow--breadcrumbs-usage",
  "viewBox": "0 0 6 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 11\" id=\"icon-arrow--breadcrumbs\"><path d=\"M1.186.21A.651.651 0 0 0 .699 0C.31 0 0 .322 0 .732c0 .204.082.39.217.533l4.11 4.241-4.11 4.23a.784.784 0 0 0-.217.532c0 .41.311.732.699.732a.651.651 0 0 0 .487-.21l4.567-4.713A.813.813 0 0 0 6 5.5a.786.786 0 0 0-.247-.57L1.186.21Z\" fill=\"#006442\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol